export const ROUTES = {
  rawFilesViewer: {
    parentPath: "/clinical-coding",
    slug: "raw-files-viewer",
    route: "/clinical-coding/raw-files-viewer",
  },
};
